import type { SidebarItem } from '@bv/router';

const sidebarItems: SidebarItem[] = [
  {
    title: 'Workspace Management',
    route: { name: 'mng-workspaces-list' },
  },
  {
    title: 'Users',
    route: { name: 'mng-users-list' },
  },
  {
    title: 'Employees',
    route: { name: 'mng-employees-list' },
  },
];

export default sidebarItems;
